

































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HotelList from './components/HotelList/index.vue'
import { daolvCity, getHotelList } from '@/api/daolv'
import { formatDate } from '@/utils/tool'
import { HOTEL_INFO } from '@/api/daolv-api'

@Component({
  name: 'hotelList',
  components: {
    HotelList
  }
})
export default class hotelList extends Vue {
  private loading = false
  private searchMuDi = '' // 目的地
  private searchCode = '' // 目的地CodeId
  private keyword = '' // 搜索关键字
  private startDay = formatDate(+new Date(), 'Y-M-D') // 用户选中入住日期
  private endDay = formatDate(+new Date() + 24 * 60 * 60 * 1000, 'Y-M-D') // 用户选中离店日期
  private startWeek = '' // 入住周期
  private endWeek = '' // 离店周期
  private readonly weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  private roomNum = 1 // 房间数量
  private adultNum = 1 // 成人数量
  private childNum = 0 // 儿童数量
  private page = 1 // 从1开始
  private resultNum = 10
  private sizeAll = 0
  private checkStarArr: Array<string> = ['不限'] // 酒店星级多选 ids
  private starRating = '' // 星级 1,2,3...
  private listData: Array<HOTEL_INFO> = [] // 酒店列表数据

  formatDate = formatDate

  private formValue = {
    minPrice: '',
    maxPrice: '',
    checkPriceId: 0 as 0 | 1 | 2 | 3 | 4 | 5 | -1 // 价格单选 label Id
  }

  private readonly priceLabelList: Array<{id: number, label: string}> = [
    {
      id: 0,
      label: '不限'
    },
    {
      id: 1,
      label: '0-100'
    },
    {
      id: 2,
      label: '100-500'
    },
    {
      id: 3,
      label: '500-1000'
    },
    {
      id: 4,
      label: '1000-5000'
    },
    {
      id: 5,
      label: '5000+'
    }
  ] // 价格选项

  private readonly hotelLabelList: Array<{star: string, label: string}> = [
    {
      star: '',
      label: '不限'
    },
    {
      star: '2',
      label: '二星及以下'
    },
    {
      star: '3',
      label: '三星'
    },
    {
      star: '4',
      label: '四星'
    },
    {
      star: '5',
      label: '五星'
    }
  ] // 星级选项

  private inputMaxPrice (value) {
    this.formValue.maxPrice = value.replace(/\D/g, '')
  }

  private inputMinPrice (value) {
    this.formValue.minPrice = value.replace(/\D/g, '')
  }

  private get priceList () {
    return {
      0: [0, 0],
      1: [0, 100],
      2: [100, 500],
      3: [500, 1000],
      4: [1000, 5000],
      5: [5000, 0]
    }
  }

  get minPrice () {
    if (this.formValue.checkPriceId >= 0) {
      return this.priceList[this.formValue.checkPriceId][0]
    }
    return this.formValue.minPrice
  }

  get maxPrice () {
    if (this.formValue.checkPriceId >= 0) {
      return this.priceList[this.formValue.checkPriceId][1]
    }
    return this.formValue.maxPrice
  }

  get queryInfo () {
    return {
      startDate: this.startDay,
      endDate: this.endDay,
      startWeek: this.startWeek,
      endWeek: this.endWeek,
      roomNum: this.roomNum,
      adultNum: this.adultNum,
      childNum: this.childNum
    }
  }

  @Watch('$route')
  setRouteActive (newValue): void {
    console.log('@Watch(route)', newValue, newValue.query)
    if (Object.keys(newValue).length > 0) {
      console.log('@Watch(route)', newValue, newValue.query)
      this.initData()
      this.getHotelList()
    }
  }

  @Watch('startDay')
  setStartDay (): void {
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
  }

  // 入住日期改变事件
  changeStartDay (value: Date): void {
    // console.log(value, this.startDay)
    if (+new Date(value) < +new Date() - 24 * 60 * 60 * 1000) {
      console.log('入住日期不能小于当天日期', formatDate(+new Date(), 'Y-M-D'))
      this.$message({
        message: '入住日期不能小于当天日期',
        type: 'warning'
      })
      this.startDay = formatDate(+new Date(), 'Y-M-D')
      return
    }
    this.startDay = formatDate(+new Date(value), 'Y-M-D')
    this.startWeek = this.weekList[new Date(value).getDay()]
    if (+new Date(this.startDay) === +new Date(this.endDay)) {
      this.$message({
        message: '入住日期不能等于离店日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
    }
    console.log(value, this.startDay, this.endDay)
  }

  // 离店日期改变事件
  changeEndDay (value: Date): void {
    // console.log(value, this.endDay)
    if (+new Date(this.startDay) > +new Date(this.endDay)) {
      console.log('离店日期不可以小于入住日期', this.endDay)
      this.$message({
        message: '离店日期不可以小于入住日期',
        type: 'warning'
      })
      this.endDay = formatDate(+new Date(this.startDay) + 24 * 60 * 60 * 1000, 'Y-M-D')
      this.endWeek = this.weekList[+new Date(this.endDay).getDay()]
      return
    }
    this.endDay = formatDate(+new Date(value), 'Y-M-D')
    this.endWeek = this.weekList[+new Date(value).getDay()]
    console.log(value, this.endDay)
  }

  // api获取城市列表
  private getCity (callback) {
    daolvCity({
      cityName: this.searchMuDi
    }).then(res => {
      if (res && res.results && res.results.length) {
        this.searchCode = res.results[0].cityCode // 1、用户输入完城市没有手动选择城市 默认选中第一个
        callback(res.results)
      } else {
        this.searchCode = ''
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 目的地输入搜索
  querySearchAsync (queryString, cb) {
    this.searchMuDi = queryString // 2、手动再更新城市
    this.getCity(cb)
  }

  // 选择的 cityCode 目的地
  private handleSelect (item) {
    console.log('handleSelect', item)
    this.searchCode = item.cityCode
  }

  // 切换分页
  currentChange (item): void {
    console.log(item)
    this.page = item
    const scrollWrapper: any = this.$refs.scrollWrapper
    scrollWrapper.scrollIntoView()
    this.getHotelList()
  }

  // 获取产品列表
  getHotelList (): void {
    this.loading = true
    getHotelList({
      cityCode: this.searchCode,
      sdate: this.startDay,
      edate: this.endDay,
      pageNo: this.page,
      pageSize: this.resultNum,
      personCount: this.adultNum + this.childNum,
      keyWord: this.keyword,
      priceFrom: this.minPrice,
      priceTo: this.maxPrice,
      starRating: this.starRating
    }).then(res => {
      console.log(res)
      this.loading = false
      if ((res && res.hotelList) || res.msg === '请求成功') {
        this.listData = res.hotelList
        this.sizeAll = res.totalCount
        // this.sizeAll = res.pageCount
      } else {
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.error(err)
    })
  }

  // 多选切换
  changeCheckbox (checkbox) {
    console.log(checkbox, this.hotelLabelList, this.checkStarArr, 'checkbox')
    // 数组转换成 1,2,3... 字符串格式
    this.starRating = this.hotelLabelList.filter((item, index) => {
      console.log(item.label, this.checkStarArr[index])
      if (this.checkStarArr.includes(item.label)) {
        return item.star
      }
    }).map(it => it.star).join(',')
    console.log(this.starRating)
    this.page = 1
    this.getHotelList()
  }

  // 单选价格
  changeRadio (radio) {
    console.log(radio, this.priceLabelList, this.formValue.checkPriceId, 'changeRadio')
    this.page = 1
    this.getHotelList()
  }

  // 改变价格
  handleChangePrice () {
    if (!this.formValue.minPrice && !this.formValue.maxPrice) {
      return this.$message({
        message: '请先输入价格',
        type: 'warning'
      })
    }
    console.log('改变价格')
    this.formValue.checkPriceId = -1
    this.page = 1
    this.getHotelList()
  }

  // 搜索
  searchData () {
    if (!this.searchMuDi) return this.$message.warning('请先选择城市')
    this.page = 1
    this.getHotelList()
  }

  // 初始化数据
  initData () {
    const {
      searchMuDi,
      searchCode,
      keyword,
      startDate,
      endDate,
      startWeek,
      endWeek,
      roomNum,
      adultNum,
      childNum
    } = this.$route.query
    if (searchMuDi) this.searchMuDi = String(searchMuDi)
    if (searchCode) this.searchCode = String(searchCode)
    if (keyword) this.keyword = String(keyword)
    if (startDate) this.startDay = String(startDate)
    if (endDate) this.endDay = String(endDate)
    if (startWeek) this.startWeek = String(startWeek)
    if (endWeek) this.endWeek = String(endWeek)
    if (roomNum) this.roomNum = Number(roomNum)
    if (adultNum) this.adultNum = Number(adultNum)
    if (childNum) this.childNum = Number(childNum)
  }

  mounted () {
    this.startWeek = this.weekList[new Date(this.startDay).getDay()]
    this.endWeek = this.weekList[new Date(this.endDay).getDay()]
    console.log(this.$route)
    this.initData()
    this.getHotelList()
  }
}
